// extracted by mini-css-extract-plugin
export var aiStarIcon = "_78-4";
export var closeButton = "_78-6";
export var dismissButton = "_78-3";
export var editImageWithAiContainer = "_78-8";
export var imageUploadWrapper = "_78-7";
export var misspelledWord = "_78-5";
export var spellCheckContainer = "_78-2";
export var spin = "_78-1";
export var spinning = "_78-0";